import React,{useEffect, useState} from 'react';
import '../warning/warning.css';
import {IsLSWork} from '../app/app'

function HowToPlay({setHowToPlayGuide}) {
  const [isLS, setIsLS] = useState(IsLSWork());
  const [white, setWhite] = useState(0);
  const [clicked, setClicked] = useState(false);

  async function go(){

    await goo();


       function goo(){
            return new Promise( async (resolve, reject) => {
              setClicked(false);
              await changeWhite();
              setHowToPlayGuide(true);
              if(isLS){
              localStorage.setItem('howToPlayGuideSC', true);
            }
              resolve();
              });
            }

  }

  useEffect(() => {
    start();
    async function start(){
      await changeWhite(true);
      setClicked(true);
    }
},[]);

  function changeWhite(toLow){
    return new Promise((resolve, reject) => {
    if(toLow){
      var op=1;
      change(toLow);
    }else{
      var op=0;
      change();
    }
    function change(toLow){
    if(toLow){
      if(op>0){
        op-=0.03;
      setWhite(op);
      setTimeout(ChangetoLow, 10);
    }else{
      resolve();
      return;
    }
  }else{
    if(op<1){
      op+=0.03;
    setWhite(op);
    setTimeout(change, 10);
  }else{
    resolve();
    return;
  }
  }

  function ChangetoLow(){
     change(true);
  }
  }
  });
  }

return(
<div className='blcwrap'>
<div className='clickWrap' onClick={clicked? go : undefined} id='wrap' style={{opacity:white}}></div>
<div className='txt1'>
<h2 style={{fontSize:"24px", marginTop:"3vh"}}><span style={{color:"#f563f7"}}>Tap</span> to continue</h2>
<h2 style={{fontSize:"24px", marginTop:"1vh"}}><span style={{color:"#f563f7"}}>Double tap</span> to speed up animations</h2>
<h2 style={{fontSize:"24px", marginTop:"1vh"}}><span style={{color:"#f563f7"}}>Tap on top</span> to see the menu button</h2>
<br/>
</div>
</div>
);

}

export default HowToPlay;
